import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"
import { useTheme } from '../../context/ThemeContext';

const Switch = React.forwardRef(({ className, ...props }, ref) => {
  const { isDark } = useTheme();

  return (
    <SwitchPrimitives.Root
      className={`peer inline-flex h-[22px] w-[40px] shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-[#cd6d2c] ${className || ''}`}
      style={{ backgroundColor: props.checked ? undefined : (isDark ? '#B3B3B3' : '#424242') }}
      {...props}
      ref={ref}
    >
      <SwitchPrimitives.Thumb
        className="pointer-events-none block h-[18px] w-[18px] rounded-full bg-white shadow-lg ring-0 transition-transform will-change-transform translate-x-[-6px] data-[state=checked]:translate-x-[12px]"
      />
    </SwitchPrimitives.Root>
  )
})
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
